<template>
  <div class="body">
    <div class="container">
      <h1>2024.10.27</h1>
      <h2>20:00 CET (GMT+01)</h2>
      <div id="countdown">
        <div class="time-section">
          <span class="time" id="days">{{ days }}</span>
        </div>
        <div class="time-section">
          <span class="time" id="hours">{{ hours }}</span>
        </div>
        <div class="time-section">
          <span class="time" id="minutes">{{ minutes }}</span>
        </div>
        <div class="time-section">
          <span class="time" id="seconds">{{ seconds }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountDown',
  data () {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: 0
    }
  },
  methods: {
    updateTime () {
      // Get today's date and time
      const countDownDate = new Date('2024-10-27T20:00:00+01:00').getTime()
      // const countDownDate = new Date('2024-10-13T20:00:00+01:00').getTime()
      const now = new Date().getTime()

      // Find the distance between now and the countdown date
      const distance = countDownDate - now

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      Object.assign(this, {
        days: days.toString().padStart(2, '0'),
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0')
      })

      // If the countdown is finished, display a message
      if (distance < 0) {
        Object.assign(this, {
          days: '00'.toString().padStart(2, '0'),
          hours: '00'.toString().padStart(2, '0'),
          minutes: '00'.toString().padStart(2, '0'),
          seconds: '00'.toString().padStart(2, '0')
        })
      }
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.updateTime()
    }, 1000)
    this.updateTime()
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
.body {
  top: 0;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  font-family: "Libre Franklin";
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #101010;
}
.container {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 600px;
  height: 600px;
  background: black;
  border-radius: 50%;
  justify-content: center;
  box-shadow: 0 0 2000px #000, 0 0 2000px #000;
}
h1 {
  color: #fff;
  letter-spacing: 0;
  font-size: 5em;
  margin-bottom: 20px;
}
h2 {
  margin-top: 0;
  font-weight: 100;
  font-size: 2em
}
#countdown {
  font-size: 3em;
  color: #fff; /* White text */
}
.time-section {
  display: inline-block;
  font-family: monospace;
  margin: 0 10px;
  font-size: 0.8em;
}
.time-section span {
  display: block;
  width: 30px;
  font-weight: 200;
  font-size: 0.9em;
  color: gray;
  text-align: left;
}
</style>
